export enum CrusherTypes {
  CH420 = 'CH420',
  CH430 = 'CH430',
  CH830i = 'CH830i',
  CH440 = 'CH440',
  CH442 = 'CH442',
  CH840i = 'CH840i',
  CH660 = 'CH660',
  CH662 = 'CH662',
  CH860i = 'CH860i',
  CH865i = 'CH865i',
  CH870i = 'CH870i',
  CH880 = 'CH880',
  CH890i = 'CH890i',
  CH895i = 'CH895i',
}

export interface AvailableBushingsMapInterface {
  [models: string]: BushingModelInterface;
}

export interface BushingModelInterface {
  concaves: BushingConcaveInterface;
}

export interface BushingConcaveInterface {
  [concave: string]: BushingThrowCombinationInterface;
}

export interface BushingThrowCombinationInterface {
  [selectedThrow: number]: string[];
}
